import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Icon } from 'antd';
import ReactMapboxGl, { Layer, Feature } from 'react-mapbox-gl';
import mapboxgl from 'mapbox-gl';
import PropTypes from 'prop-types';

import settings from 'front-settings';

import { DEFAULT_PAINT, HOVERED_PAINT, SELECTED_PAINT } from 'components/Summary/ParkingsMap/parkingsMap.config';
import { removeParking, addParking } from 'modules/userrequest';

import { map as styleMap } from 'components/TerraDrawMap/TerraDrawMap.module.scss';
import 'mapbox-gl/dist/mapbox-gl.css';

const Map = ReactMapboxGl({
  accessToken: settings.MAPBOX_ACCESS_TOKEN,
  maxZoom: 21,
  minZoom: 8,
});

const popup = new mapboxgl.Popup();

export class ParkingsMap extends React.Component {
  static propTypes = {
    center: PropTypes.array.isRequired,
    zoom: PropTypes.array.isRequired,
    maxBounds: PropTypes.arrayOf(PropTypes.array.isRequired).isRequired,
  }

  state = {
    center: this.props.center,
    zoom: this.props.zoom,
    selectedFeatureId: '',
  };

  showParking = (map, e) => {
    const featureBbox = [[e.point.x - 5, e.point.y - 5], [e.point.x + 5, e.point.y + 5]];
    const currentFeature = map.queryRenderedFeatures(featureBbox)
      .filter(({ properties: { CODE_FRT } }) => typeof CODE_FRT === 'string')
      .map(({ properties }) => properties);

    if (!currentFeature.length) {
      popup.remove();
      return this.setState({ selectedFeatureId: '' });
    }

    const [{
      NAME: name,
      hash,
      FRQ: frequentation,
      BUS_CPY: busCapacity,
      LV_CPY: lvCapacity,
    }] = currentFeature;
    this.setState({ selectedFeatureId: hash });

    return popup
      .setLngLat([e.lngLat.lng, e.lngLat.lat])
      .setHTML(`
        <p>
          <strong>
            ${name}
          </strong>
        </p>
        <p>
        ${+lvCapacity
        ? `Nombre de places pour les véhicules légers : <strong>${lvCapacity}</strong>`
        : "Aucune place véhicule léger n'est disponible"}
        </p>
        <p>
        ${+busCapacity
          ? `Nombre de places pour les bus : <strong>${busCapacity}</strong>`
          : "Aucune place bus n'est disponible"}
        </p>
        <p>Le niveau de fréquentation est <strong>${frequentation}</strong></p>`)
      .addTo(map);
  }

  addHoveredParking = () => {
    const { parkings, selectedParkings } = this.props;
    const { selectedFeatureId } = this.state;

    if (!selectedFeatureId) return;

    const parking = parkings.find(({ properties: { id } }) => id === selectedFeatureId);
    const parkingIndex = selectedParkings
      .findIndex(({ properties: { id } }) => id === selectedFeatureId);

    if (parkingIndex > -1) {
      this.props.removeParking(parkingIndex);
    } else {
      this.props.addParking(parking);
    }
  }

  render () {
    const { showParking, addHoveredParking } = this;
    const { maxBounds, selectedParkings, parkings = [] } = this.props;
    const { zoom, center, selectedFeatureId } = this.state;

    if (!parkings.length) return <Icon type="loading" theme="outlined" spin />;

    return (
      <div className={styleMap}>
        <Map
          style="mapbox://styles/makinacorpus/cjpchq1n03xeb2rqrmw59tmmm" // eslint-disable-line react/style-prop-object
          containerStyle={{ height: '30rem', width: '100%' }}
          maxBounds={maxBounds}
          center={center}
          zoom={zoom}
          onMouseMove={showParking}
          onClick={addHoveredParking}
        >
          <Layer
            type="circle"
            paint={DEFAULT_PAINT}
          >
            {parkings.filter(({ properties: { id } }) => id !== selectedFeatureId)
              .map(({ geometry: { coordinates }, properties }) => (
                <Feature
                  key={JSON.stringify(coordinates)}
                  coordinates={coordinates}
                  properties={{ ...properties, hash: properties.id }}
                />
              ))}
          </Layer>

          <Layer
            type="circle"
            paint={HOVERED_PAINT}
          >
            {parkings.filter(({ properties: { id } }) => id === selectedFeatureId)
              .map(({ geometry: { coordinates }, properties }) => (
                <Feature
                  key={JSON.stringify(coordinates)}
                  coordinates={coordinates}
                  properties={{ ...properties, hash: properties.id }}
                />
              ))}
          </Layer>

          <Layer
            type="circle"
            paint={SELECTED_PAINT}
          >
            {selectedParkings.length
            && selectedParkings.map(({ geometry: { coordinates }, properties }) => (
              <Feature
                key={JSON.stringify(coordinates)}
                coordinates={coordinates}
                properties={{ ...properties, hash: properties.id }}
              />
            ))}
          </Layer>
        </Map>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  parkings: state.userrequestParkings.parkings,
  selectedParkings: state.userrequest.properties.parkings,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  removeParking,
  addParking,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ParkingsMap);



// WEBPACK FOOTER //
// ./src/components/Summary/ParkingsMap/index.js